import React from 'react';
import {BaseToolbarJson, BaseToolbarSelect,BaseInput} from 'wsc-react-custom-form';

export const Settings = () => {
  return (
    <>
       <BaseToolbarJson propKey="map" label="映射关系" />
       <BaseInput propKey='label' label='Label' tooltipTitle='标签' widthRation={50} />
       <BaseToolbarSelect
          propKey='hidden'
          label='隐藏'
          tooltipTitle='隐藏'
          options={[
            { value: 'true', label: '是' },
            { value: 'false', label: '否' },
          
          ]}
          widthRation={50}
        />
         <BaseInput propKey='labelSpan' label='labelSpan' tooltipTitle='标签宽度（labelSpan）' widthRation={50} />
      <BaseInput propKey='labelOffset' label='labelOffset' tooltipTitle='标签偏移量（labelOffset）' widthRation={50} />
      <BaseInput propKey='wrapperSpan' label='wrapperSpan' tooltipTitle='表单组件宽度（wrapperSpan）' widthRation={50} />
      <BaseInput propKey='wrapperOffset' label='wrapperOffset' tooltipTitle='表单组件偏移量（wrapperOffset）' widthRation={50} />
    </>
  );
};
